<template>
  <transition-group tag="ul" :name="transition"  class="blog__feed">
    <li v-for="(post, index ) in feed_filter" class="preview" :key="post.id">
      <figure class="preview__figure" :class="figureClass" :style="getBgImg(post.images)">
        <transition name="v--fade">
          <figcaption v-if="!reading || $device.phone" class="preview__details">
            <router-link class="preview__title"
              :to="`/blog/${post.slug}`"
              @click.native="scrollTo(0, 220, scrollDelay)">
              {{ post.title }}
            </router-link>

            <div class="preview__meta">
              <time class="preview__published">
                {{ prettyDate(post.created_at) }}
              </time>
              <router-link v-for="(category,index) in post.subjectblogs" class="preview__author"
                :to="`/blog/category/${kebabify(category.slug)}`"
                @click.native="scrollTo(0, 220, scrollDelay)" :key="category.id">
                {{ category.title }} <span v-show="index<(post.subjectblogs.length-1)">|</span>
              </router-link>
            </div>
          </figcaption>
        </transition>
      </figure>
    </li>
  </transition-group>
</template>

<script>
import { scrollTo, kebabify, prettyDate } from '../helpers'

export default {
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    feed: {
      type: Array,
      default: () => []
    },
    begin: {
      type: Number,
      default: () => 0
    },
    website: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      transition: 'preview-appear'
    }
  },

  computed: {
    reading() { return this.filters.post },
    scrollDelay() { return (this.$device.phone) ? 0 : 560 },
    figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading }
    },
    feed_filter() {
      // const filterBy = {
      //   post: (filter, { id }) => filter === id,
      //   author: (filter, { gender }) => {
      //     return filter === gender;
      //   },
      //   search: (filter, { title }) => {
      //     return this.kebabify(title).includes(filter);
      //   }
      // }
      // if (!Object.keys(this.filters).length) return this.feed

      // return this.feed.filter(post => {
      //   return Object.keys(this.filters).every(filter => {
      //     return filterBy[filter](this.filters[filter], post)
      //   })
      // })
      const filterBy = {
        post: (filter, { slug }) => filter === slug
      }
      if (!Object.keys(this.filters).length) return this.feed
      return this.feed.filter(post => {
        return Object.keys(this.filters).every(filter => {
          if (typeof filterBy[filter] !== 'undefined') {
            return filterBy[filter](this.filters[filter], post)
          } else {
            return this.feed;
          }
        })
      })
    }
  },
  updated() {
    // this.$emit('loadfeed');
  },
  methods: {
    scrollTo,
    kebabify,
    prettyDate,
    getBgImg(src) {
      if (src !== '') {
        if (src.includes('http://') || src.includes('https://')) {
          return { backgroundImage: `url(${src})` }
        }
        var arrSrc = src.split(';');
        return { backgroundImage: `url(${this.website + '/image/' + arrSrc[0]})` }
      }
      // retrurn default nophoto
      return { backgroundImage: `url(${src})` }
    },
    stackPosts(posts) {
      let interval
      const stack = () => {
        this.posts.push(posts.shift())

        if (!posts.length) {
          this.transition = 'preview'
          clearInterval(interval)
        }
      }

      interval = setInterval(stack, 125)
    },
    setbegin: function () {
      this.$emit('setBegin', 1);
    }
  },

  mounted() {
    // this.$getResource('feed')
    //   .then(posts => {
    //     if (!Object.keys(this.filters).length) {
    //       this.stackPosts(posts)
    //     } else {
    //       this.posts = posts
    //       this.transition = 'preview'
    //     }
    //   })
    this.$nextTick(function () {
      this.feed = this.$props.feed;
      this.website = this.$props.website;
      this.transition = 'preview'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogFeed.vue